<script lang="ts">
	import Slider from '@smui/slider';
	import FormField from '@smui/form-field';
	import Katex from './Katex.svelte';
	
	export let aSlide: number;
	export let aString = "a";
	export let aMin = -9;
	export let aMax = 9;
	export let aStep = 1;
	let aPrev: number;

	// reactive
	$: aPrev = updateSlider(aSlide);

	function updateSlider(a1:number){
		if (a1==0){
			if (aPrev>0){
				aPrev = -1;
				aSlide = -1;
			} else{
				aPrev = -1;
				aSlide = -1;
			}
		} else{
			aPrev = a1;
		}
		return aPrev
	}
</script>


<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={aSlide} min={aMin} max={aMax} step={aStep} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={aString+"="+aSlide.toString()}/></span>
	</FormField>
</div>